var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { "justify-end": "" } },
    [
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "500px", scrollable: "" },
          model: {
            value: _vm.localDialog,
            callback: function($$v) {
              _vm.localDialog = $$v
            },
            expression: "localDialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [
                _c("span", { staticClass: "headline" }, [
                  _vm._v(_vm._s(_vm.formTitle))
                ])
              ]),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-container",
                    { attrs: { fluid: "" } },
                    [
                      _c(
                        "v-layout",
                        {
                          attrs: {
                            "align-space-around": "",
                            "justify-center": "",
                            column: ""
                          }
                        },
                        [
                          _c(
                            "v-form",
                            {
                              ref: "form",
                              attrs: { "lazy-validation": "" },
                              model: {
                                value: _vm.valid,
                                callback: function($$v) {
                                  _vm.valid = $$v
                                },
                                expression: "valid"
                              }
                            },
                            [
                              _c("v-text-field", {
                                attrs: { label: "Name" },
                                model: {
                                  value: _vm.local.name,
                                  callback: function($$v) {
                                    _vm.$set(_vm.local, "name", $$v)
                                  },
                                  expression: "local.name"
                                }
                              }),
                              _vm._v(" "),
                              _c("v-text-field", {
                                attrs: { label: "File Name" },
                                model: {
                                  value: _vm.local.filename,
                                  callback: function($$v) {
                                    _vm.$set(_vm.local, "filename", $$v)
                                  },
                                  expression: "local.filename"
                                }
                              }),
                              _vm._v(" "),
                              _c("v-text-field", {
                                attrs: { label: "Service" },
                                model: {
                                  value: _vm.local.service,
                                  callback: function($$v) {
                                    _vm.$set(_vm.local, "service", $$v)
                                  },
                                  expression: "local.service"
                                }
                              }),
                              _vm._v(" "),
                              _c("v-textarea", {
                                attrs: { label: "Description" },
                                model: {
                                  value: _vm.local.description,
                                  callback: function($$v) {
                                    _vm.$set(_vm.local, "description", $$v)
                                  },
                                  expression: "local.description"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "audio-uploader",
                                {
                                  on: { input: _vm.assignAudio },
                                  model: {
                                    value: _vm.local.audio,
                                    callback: function($$v) {
                                      _vm.$set(_vm.local, "audio", $$v)
                                    },
                                    expression: "local.audio"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "activator" },
                                      slot: "activator"
                                    },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: "Upload Audio",
                                          disabled: "",
                                          "prepend-icon": "attach_file"
                                        },
                                        model: {
                                          value: _vm.local.audio.audioName,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.local.audio,
                                              "audioName",
                                              $$v
                                            )
                                          },
                                          expression: "local.audio.audioName"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm.local.audio
                                ? _c("div", [
                                    _vm.local.audio.audioURL
                                      ? _c(
                                          "div",
                                          [
                                            _c("vuetify-audio", {
                                              attrs: {
                                                file: _vm.local.audio.audioURL
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", outline: "" },
                      on: { click: _vm.close }
                    },
                    [_vm._v("Cancel")]
                  ),
                  _vm._v(" "),
                  _vm.showSaveButton
                    ? _c(
                        "v-btn",
                        {
                          attrs: { color: "primary" },
                          on: { click: _vm.save }
                        },
                        [
                          this.saving
                            ? _c(
                                "v-flex",
                                [
                                  _c("v-progress-circular", {
                                    attrs: {
                                      indeterminate: "",
                                      color: "primary"
                                    }
                                  })
                                ],
                                1
                              )
                            : _c("v-flex", [_vm._v("Save")])
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4ad5a510", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad5a510","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/assets/add-new/addVoice.vue
// module id = null
// module chunks = 